<template>
  <form>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <o-icon
          clickable
          native-type="button"
          icon="times"
          @click.native="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <o-tabs v-model="activeTab" position="centered" :expanded="true">
          <o-tab-item value="text" label="Text Field" :disabled="mode && mode !== 'text'">
            <div class="columns">
              <div class="column">
                <o-field label="Key">
                  <o-input v-model="textForm.key"></o-input>
                </o-field>
              </div>
              <div class="column">
                <o-field label="Title">
                  <o-input v-model="textForm.title"></o-input>
                </o-field>
              </div>
            </div>
            <o-field label="Placeholder">
              <o-input v-model="textForm.placeholder"></o-input>
            </o-field>
          </o-tab-item>

          <o-tab-item value="image" label="Image Field" :disabled="mode && mode !== 'image'">
            <div class="columns">
              <div class="column">
                <o-field label="Key">
                  <o-input v-model="imageForm.key"></o-input>
                </o-field>
              </div>
              <div class="column">
                <o-field label="Title">
                  <o-input v-model="imageForm.title"></o-input>
                </o-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <o-field label="Width">
                  <o-input v-model="imageForm.width"></o-input>
                </o-field>
              </div>
              <div class="column">
                <o-field label="Height">
                  <o-input v-model="imageForm.height"></o-input>
                </o-field>
              </div>
            </div>
            <o-field>
              <o-switch v-model="imageForm.disable" :falseValue="'off'" :trueValue="'on'">Disable</o-switch>
            </o-field>
          </o-tab-item>

          <o-tab-item value="combo" label="Combo Field" :disabled="mode && mode !== 'combo'">
            <div class="columns">
              <div class="column">
                <o-field label="Key">
                  <o-input v-model="comboForm.key"></o-input>
                </o-field>
              </div>
              <div class="column">
                <o-field label="Title">
                  <o-input v-model="comboForm.title"></o-input>
                </o-field>
              </div>
            </div>
            <hr/>
            <div class="p-2" v-if="comboForm.values">
              <div class="columns" v-for="item in comboForm.values">
                <div class="column">
                  <o-field label="Label">
                    <o-input v-model="item.label"></o-input>
                  </o-field>
                </div>
                <div class="column">
                  <o-field label="Value">
                    <o-input v-model="item.value"></o-input>
                  </o-field>
                </div>
              </div>
            </div>
            <o-button class="m-2" variant="primary" @click="addNewComboFieldsSet()">Add New Fields Set</o-button>
          </o-tab-item>
        </o-tabs>

      </section>
      <footer class="modal-card-foot">
        <o-button type="button" @click="$emit('close')">Close</o-button>
        <o-button variant="primary" @click="save()">Save</o-button>
      </footer>
    </div>
  </form>


</template>

<script>
export default {
  name: "CustomFieldsModal",
  props: ['title', 'initialData'],
  data() {
    return {
      activeTab: this.initialData ? this.initialData.type : "text",
      mode: this.initialData ? this.initialData.type : null,

      textForm: {
        type: "text",
        key: null,
        title: null,
        placeholder: null
      },
      imageForm: {
        type: "image",
        key: null,
        title: null,
        disable: "off",
        height: 0,
        width: 0,
      },
      comboForm: {
        type: "combo",
        key: null,
        title: null,
        values: [{'label': null, 'value': null}]
      }
    }
  },
  methods: {
    addNewComboFieldsSet() {
      this.comboForm.values.push({'label': null, 'value': null})
    },
    save() {
      const forms = [this.textForm, this.imageForm, this.comboForm]
      const active = forms.find(form => form.type === this.activeTab)
      if (active) {
        if (!active.key)
          this.$oruga.notification.open({
            message: 'Key is empty',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })

        if (!active.title)
          this.$oruga.notification.open({
            message: 'Title is empty',
            rootClass: 'toast-notification-danger',
            position: 'top',
            duration: 3000
          })

        if (active.key && active.title) {
          this.$emit('onComplete', active)
          this.$emit('close')
        }

      }
    }
  },
  created() {
    if (this.initialData) {
      switch (this.initialData.type) {
        case 'text':
          this.textForm = this.initialData
          break;
        case 'image':
          this.imageForm = this.initialData
          break;
        case 'combo':
          this.comboForm = this.initialData
          break;
        default:
          console.log(`Not found type ${this.initialData.type}.`);
      }

    }
  }

}
</script>

<style scoped>

</style>
